/*
 *
 * SecondaryUserShopListModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 08-Oct-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (<PortalMessage id='t.app.secondaryUser.shopList' defaultMessage='Lista punti vendita' />),
  closeLabel: <PortalMessage id='t.app.close' defaultMessage='Chiudi' />,
  sectionTitle: <PortalMessage id='t.app.secondaryUser.shopList.sectionTitle' defaultMessage='L’utenza ha visibilità dei seguenti punti vendita.' />,
  totalLabel: <PortalMessage id='t.app.secondaryUser.shopList.totalLabel' defaultMessage='Totale punti vendita assegnati' />
}

export default formattedMessage
